import { mapActions } from "vuex";

export const recaptcha = {
  methods: {
    ...mapActions(["showSnackbarError"]),
    async executeRecaptcha() {
      try {
        await window.grecaptcha.execute();
        this.recaptchaValue = await new Promise(resolve => {
          const interval = setInterval(() => {
            const response = window.grecaptcha.getResponse();
            if (response !== "") {
              clearInterval(interval);
              resolve(response);
            }
          }, 200);
        });
      } catch (error) {
        this.showSnackbarError(error);
      }
    },
    onCaptchaExpired() {
      window.grecaptcha.reset();
    },
  },
  data() {
    return {
      recaptchaValue: "",
      recaptchaKey: "",
    };
  },
};

export default recaptcha;
